import React from "react";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";

export default function lineChart({ chartData }) {
  console.log(Chart);

  return <Line data={chartData} />;
}
